import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const statusModeAtom = atom<"status" | "price">({
    key: ATOM_KEY.STATUS_MODE,
    default: "status",
});

export const useStatusModeValue = () => useRecoilValue(statusModeAtom);
export const useSetStatusModeState = () => useSetRecoilState(statusModeAtom);
export const useStatusModeState = () => useRecoilState(statusModeAtom);
